import { set } from 'date-fns';

/** The time at or before `date` that the dial can land on: minutes floored to `step`, no seconds. */
export const snapToStep = (date: Date, step: number) =>
  set(date, {
    minutes: Math.floor(date.getMinutes() / step) * step,
    seconds: 0,
    milliseconds: 0,
  });
